export const INVITE_STATUSES = {
  ANSWERED: 'answered',
};
